import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ui-fullscreen',
  templateUrl: './fullscreen.component.html',
  styleUrls: [ './fullscreen.component.less' ],
})
export class UiFullscreenComponent {}
